<template>
  <div
    class="h-10 border-4 border-b-0 border-orange month-selector top-1 bg-white flex flex-row items-center"
  >
    <div
      v-for="i in 9"
      :key="i + 3"
      class="mr-3 text-center cursor-pointer"
      style="width: 28px; height: 28px;"
      :class="
        currentMonth == i + 3 ? 'current-month rounded-full bg-orange' : ''
      "
      @click="setMonth(i + 3)"
    >
      <span class="text-orange text-lg">{{ i + 3 }}</span>
    </div>
    <div
      v-for="i in 3"
      :key="i"
      class="mr-3 text-center cursor-pointer"
      style="width: 28px; height: 28px;"
      :class="[currentMonth == i ? 'current-month rounded-full bg-orange' : '']"
      @click="setMonth(i)"
    >
      <span class="text-orange text-lg">{{ i }}</span>
      <span v-if="i == 3" class="text-orange text-sm">月</span>
    </div>
  </div>
</template>

<script>
import { useMonthSelector } from '@/services/useMonthSelector'

export default {
  name: 'AppMonthSelector',

  setup() {
    return { ...useMonthSelector() }
  },
}
</script>
<style lang="scss">
.month-selector {
  border-radius: 20px;
  width: 488px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  box-sizing: border-box;
  position: relative;
}

.current-month {
  span {
    color: #fff;
    font-weight: bold;
  }
}
</style>
